import { faSquareArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import { Card, Icon, Link, CardColors, Text, Image } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

import { useReselector } from '@/utils/sharedHooks'
import { getGroupedActiveTaxEstimatesWithinActiveQuarter } from '@/features/taxes/quarterly/userTaxEstimates.selector'
import { shortNames } from '@/constants/statesShortNamesConstants'
import { STATE_QUARTERLY_TAX_PAYMENTS } from '@/features/taxes/taxConstants'

export const StateSafeHarborCard = ({
  forLastQuarter,
}: {
  forLastQuarter?: boolean
}) => {
  const { stateTaxEstimates } = useReselector(
    getGroupedActiveTaxEstimatesWithinActiveQuarter
  )

  const bodyText = forLastQuarter
    ? "We’re unable to provide a safe harbor estimate for state taxes. However, we’ll provide a state estimate for the upcoming deadline when our Quarterly Checklist opens later this quarter. In the meantime, visit your state's website for information on how to calculate your estimated taxes."
    : "We’re unable to provide an estimate since it's so late in the quarter. However, we’ll provide you with your state estimate next quarter. In the meantime, visit your state's website for information on how to calculate your estimated taxes."

  return (
    <Card color={CardColors.LEVEL_1}>
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-8 items-start">
        <div className="w-full lg:w-[150px] lg:shrink-0 flex justify-center">
          <Image
            src="https://heard-images.s3.amazonaws.com/assets/question_coin.svg"
            className="w-[150px] h-[150px]"
            alt="Question Coin"
          />
        </div>

        <div className="w-full lg:flex-1 space-y-4">
          <Text variant={TypographyStyles.H2}>What about state taxes?</Text>

          <Text color={TextColors.MUTED}>{bodyText}</Text>

          {stateTaxEstimates?.map((estimate) => {
            const state = estimate.filingState
            const helpArticleLink =
              state && STATE_QUARTERLY_TAX_PAYMENTS[state]?.helpArticle
            const longName = state && shortNames[state]

            if (!helpArticleLink || !longName) return null

            return (
              <div key={estimate.id}>
                <Link href={helpArticleLink} newPage>
                  <Icon icon={faSquareArrowUpRight} className="mr-2 inline" />
                  {longName} taxes
                </Link>
              </div>
            )
          })}
        </div>
      </div>
    </Card>
  )
}
